import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface InfoIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function InfoIcon({ className, ...props }: InfoIconProps) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-5', className)}
      aria-hidden="true"
      {...props}
    >
      <path d="M7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0ZM7.5 1.40625C4.13451 1.40625 1.40625 4.13451 1.40625 7.5C1.40625 10.8655 4.13451 13.5938 7.5 13.5938C10.8655 13.5938 13.5938 10.8655 13.5938 7.5C13.5938 4.13451 10.8655 1.40625 7.5 1.40625ZM7.56738 6.2959C7.91261 6.2959 8.19226 6.5757 8.19238 6.9209V10.377C8.19218 10.7221 7.91256 11.002 7.56738 11.002C7.22226 11.0019 6.94258 10.722 6.94238 10.377V6.9209C6.94251 6.57575 7.22222 6.29597 7.56738 6.2959ZM7.5625 4.09082C7.97295 4.09082 8.30762 4.40595 8.30762 4.81641C8.30759 5.22684 7.97294 5.54199 7.5625 5.54199C7.15217 5.54187 6.81839 5.22676 6.81836 4.81641C6.81836 4.40603 7.15215 4.09094 7.5625 4.09082Z" fill="currentColor" />
    </svg>
  );
}

export function InfoIconLg({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-8', className)}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
      <path
        d="M11.1076 17.6031V10.0737H13.1084V17.6031H11.1076ZM10.9091 7.70638C10.9091 7.04965 11.4436 6.54565 12.1004 6.54565C12.7571 6.54565 13.2916 7.04965 13.2916 7.70638C13.2916 8.36311 12.7571 8.86711 12.1004 8.86711C11.4436 8.86711 10.9091 8.36311 10.9091 7.70638Z"
        fill="currentColor"
      />
    </svg>
  );
}
